import React, { useEffect, useState } from 'react'
import axios from "axios";
import { StudentArea } from '../../Components/StudentArea'
import { api_url } from "../../Hooks/Global";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const AllCourses = () => {
    const navigate = useNavigate();

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('*');
    const [keyword, setKeyword] = useState("");
    const [applyFilter, setApplyFilter] = useState(false);

    const getCourses = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${api_url}Masters/GetAllPrograms`, {
                params: { keyword }
            });

            const { success, data = [] } = response.data;

            if (success) {
                setCourses(data);
            } else {
                setCourses([]);
            }
        } catch (error) {
            console.error("Error fetching courses:", error);
            setCourses([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCourses();
    }, [applyFilter]);

    // Function to determine category class based on program_title or program_type
    const getCategoryClass = (course) => {
        const title = (course.program_title || '').toLowerCase();
        const shortTitle = (course.program_short_title || '').toLowerCase();

        if (title.includes('diploma') || shortTitle.includes('diploma')) return 'diploma';
        if (title.includes('short') || shortTitle.includes('short term')) return 'shortterm';
        if (title.includes('technical') || shortTitle.includes('technical')) return 'technical';
        if (title.includes('fashion') || title.includes('parlour')) return 'fashionDesigning';
        if (title.includes('computer') || title.includes('ms office') || title.includes('dtp') || title.includes('typing')) return 'computer';
        return 'diploma';
    };

    // Format duration (assuming program_duration is in days)
    const formatDuration = (duration) => {
        if (!duration) return 'Duration not specified';
        const days = parseInt(duration);
        const months = Math.round(days / 30);
        return `${months} Month${months > 1 ? 's' : ''} Course`;
    };

    // Filter courses based on selected category
    const getFilteredCourses = () => {
        if (filter === '*') return courses;
        return courses.filter(course => getCategoryClass(course) === filter);
    };

    const filteredCourses = getFilteredCourses();

    const handleSearch = () => {
        setApplyFilter(prev => !prev);
    };

    const handleClear = () => {
        setKeyword("");
        setApplyFilter(prev => !prev);
    };

    return (
        <>
            <StudentArea />
            <div className="courses-page-area2">
                <div className="container" id="inner-isotope">
                    {/* Search and Filter Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            {/* Search Row */}
                            <div className="row g-3 mb-3">
                                <div className="col-md-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by course title or code..."
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") handleSearch();
                                        }}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-warning flex-grow-1"
                                            onClick={handleSearch}
                                            disabled={loading}
                                        >
                                            <i className="fa fa-search me-1"></i> Search
                                        </button>
                                        <button
                                            className="btn btn-secondary flex-grow-1"
                                            onClick={handleClear}
                                            disabled={loading}
                                        >
                                            <i className="fa fa-refresh me-1"></i> Reset
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Category Filter Row */}
                            {/* <div className="row">
                                    <div className="col-12">
                                        <div className="isotop-classes-tab isotop-btn d-flex flex-wrap gap-2 justify-content-center">
                                            <a
                                                href="#"
                                                data-filter="*"
                                                className={`btn btn-sm ${filter === '*' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFilter('*');
                                                }}
                                            >
                                                All Courses
                                            </a>
                                            <a
                                                href="#"
                                                data-filter=".diploma"
                                                className={`btn btn-sm ${filter === '.diploma' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFilter('.diploma');
                                                }}
                                            >
                                                Diploma
                                            </a>
                                            <a
                                                href="#"
                                                data-filter=".shortterm"
                                                className={`btn btn-sm ${filter === '.shortterm' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFilter('.shortterm');
                                                }}
                                            >
                                                Short Term
                                            </a>
                                            <a
                                                href="#"
                                                data-filter=".technical"
                                                className={`btn btn-sm ${filter === '.technical' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFilter('.technical');
                                                }}
                                            >
                                                Technical
                                            </a>
                                            <a
                                                href="#"
                                                data-filter=".fashionDesigning"
                                                className={`btn btn-sm ${filter === '.fashionDesigning' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFilter('.fashionDesigning');
                                                }}
                                            >
                                                Fashion Designing & Parlour
                                            </a>
                                            <a
                                                href="#"
                                                data-filter=".computer"
                                                className={`btn btn-sm ${filter === '.computer' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setFilter('.computer');
                                                }}
                                            >
                                                Computer
                                            </a>
                                        </div>
                                    </div>
                                </div> */}
                        </div>
                    </div>

                    {/* Courses Grid Section */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card bg-transparent border-0">
                                <div className="row g-4">
                                    {loading ? (
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <div className="mt-2 text-muted">Loading courses...</div>
                                        </div>
                                    ) : filteredCourses.length > 0 ? (
                                        filteredCourses.map((course, index) => (
                                            <div
                                                key={course.master_program_id || index}
                                                className={`col-lg-4 col-md-6 col-sm-12 d-flex ${getCategoryClass(course)}`}
                                            >
                                                <div className="card1 shadow-lg text-center w-100">
                                                    <p className="item-content fw-bold">
                                                        {course.program_title || 'Course Title Not Available'}
                                                    </p>
                                                    <p style={{ fontSize: '15px' }}>
                                                        {formatDuration(course.program_duration)}
                                                    </p>
                                                    <div className="go-corner" href="#">
                                                        <div className="go-arrow">
                                                            →
                                                        </div>
                                                    </div>
                                                    <button
                                                        className='btn btn-sm view-all-accent-btn'
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (course.syllabus_url) {
                                                                window.open(course.syllabus_url, '_blank');
                                                            } else {
                                                                Swal.fire({
                                                                    icon: 'info',
                                                                    title: 'Syllabus Coming Soon',
                                                                    text: 'The syllabus for this course is not available yet. Please check back later or contact the council.',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'OK',
                                                                    cancelButtonText: 'Contact Us',
                                                                }).then((result) => {
                                                                    if (result.dismiss === Swal.DismissReason.cancel) {
                                                                        navigate('/contact');
                                                                    }
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        View Syllabus
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="col-12 text-center py-5">
                                            <div className="fw-semibold">No Courses Found</div>
                                            <div className="text-muted small">No courses available at the moment.</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllCourses